<template>
  <div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`utasbiztositott_nev_${pKey}`"
        >Név <span v-if="selectable" class="text-danger">*</span></label
      >
      <ValidationProvider
        rules="required"
        name="mező"
        v-slot="{errors, classes}"
        class="col-sm-8"
        v-if="selectable"
      >
        <input
          class="form-control dark-border"
          type="text"
          v-model="name"
          :id="`utasbiztositott_nev_${pKey}`"
          :class="classes"
        />
        <small class="text-danger input-alert">{{ errors[0] }}</small>
      </ValidationProvider>
      <div class="col-sm-8" v-else>
        {{ name }}
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`utasbiztositott_szuldat_${pKey}`"
        >Születési dátum <span v-if="selectable" class="text-danger">*</span></label
      >
      <div class="col-sm-8" v-if="selectable">
        <input
          class="form-control dark-border"
          type="date"
          :min="birthMinDate"
          :max="birthMaxDate"
          v-model="bornDate"
          required
        />
        <!-- <Datepicker
          :format="'yyyy-MM-dd'"
          :placeholder="'ÉÉÉÉ-HH-NN'"
          :language="hu"
          :disabled-dates="disabledDates"
          :typeable="true"
          v-model="bornDate"
          :bootstrap-styling="true"
          :required="true"
        ></Datepicker> -->
        <ValidationProvider
          :immediate="true"
          rules="required|szuletes_datum"
          name="mező"
          v-slot="{errors}"
        >
          <input type="text" :value="bornDate" disabled hidden />
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="col-sm-8" v-else>
        {{ new Date(bornDate).toLocaleDateString('hu-HU') }}
      </div>
    </div>
    <div class="form-group row" v-if="selectable">
      <label class="col-sm-4">
        Biztosított törlése<br />
        <span class="text-danger fw-normal">A törléssel a beírt adatok elvesznek.</span>
      </label>
      <div class="col-sm-8">
        <div class="btn btn-red w-100" @click="deleteInsuredPerson">Törlés</div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {hu} from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

export default {
  props: ['pKey', 'person', 'selectable'],
  components: {
    Datepicker,
  },
  data() {
    // const now = new Date();
    // const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    // const minDate = new Date(today);
    // minDate.setFullYear(1900);
    // minDate.setMonth(1);
    // minDate.setDate(1);
    const today = new Date();
    const minDate = new Date();

    const birthMinDate = moment(minDate).format('YYYY-MM-DD');
    const birthMaxDate = moment(maxDate).format('YYYY-MM-DD');

    return {
      hu: hu,
      disabledDates: {
        customPredictor: function(date) {
          return date > today || date < minDate;
        },
      },
      birthMaxDate,
      birthMinDate,
    };
  },
  computed: {
    name: {
      get() {
        return this.$store.state.chooseableAccesories.travelInsuranced.list[this.pKey].name;
      },
      set(value) {
        this.$store.commit('updateInsuredPerson', {index: this.pKey, key: 'name', value: value});
      },
    },
    bornDate: {
      get() {
        return this.$store.state.chooseableAccesories.travelInsuranced.list[this.pKey].bornDate;
      },
      set(value) {
        this.$store.commit('updateInsuredPerson', {
          index: this.pKey,
          key: 'bornDate',
          value: value,
        });
      },
    },
  },
  methods: {
    deleteInsuredPerson() {
      if (!this.selectable) return;
      this.$store.commit('deleteInsuredPerson', this.pKey);
    },
  },
};
</script>
